import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;
if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1"),
    beforeSend(event) {
      if (event.user) delete event.user.email;
      if (event.request) {
        delete event.request.cookies;
        delete event.request.query_string;
      }
      return event;
    },
  });
}

export { Sentry };
